module.exports = __webpack_public_path__ + "static/media/manager-b-3.342b7d29.png";